import {
  AtsCandidateEmailActionDelaysEnum,
  AtsCandidateEmailActionSenderOptionsEnum,
  AtsCandidateEmailActionTypesEnum,
  AtsHiringStageNamesEnum,
} from 'generated/resources/graphql'
import moment, { Moment } from 'moment'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

type SidepanelSettings = {
  [key in AtsCandidateEmailActionTypesEnum]: {
    withoutStages: AtsHiringStageNamesEnum[]
  }
}
export const delayLabel = (delay: AtsCandidateEmailActionDelaysEnum) => {
  switch (delay) {
    case 'now':
      return i18n.t('ats.candidates.messages.email_actions_delayed_messages.send_now')
    case 'two_hours':
      return i18n.t('ats.candidates.messages.email_actions_delayed_messages.send_later_2_hours')
    case 'four_hours':
      return i18n.t('ats.candidates.messages.email_actions_delayed_messages.send_later_4_hours')
    case 'six_hours':
      return i18n.t('ats.candidates.messages.email_actions_delayed_messages.send_later_6_hours')
    case 'today_at_six_pm':
      return i18n.t('ats.candidates.messages.email_actions_delayed_messages.send_today_6_pm')
    case 'tomorrow_at_nine_am':
      return i18n.t('ats.candidates.messages.email_actions_delayed_messages.send_tomorrow')
    case 'next_monday_at_nine_am':
      return i18n.t('ats.candidates.messages.email_actions_delayed_messages.send_next_monday')
    default:
      return delay
  }
}

export const sendFromLabel = (sendFrom: string) => {
  switch (sendFrom) {
    case 'no_reply':
      return i18n.t('ats.smart_actions.sender_options.no_reply')
    case 'conversation':
      return i18n.t('ats.smart_actions.sender_options.conversation')
    default:
      return sendFrom
  }
}

export const sendAsCorporateEmail = (sender: AtsCandidateEmailActionSenderOptionsEnum) => {
  return 'no_reply' === sender
}

export const isCustomDateTimeValue = (value: string): boolean => {
  return Boolean(value && value.includes('T') && value.includes('-'))
}

export const getDelayTime = (delay: AtsCandidateEmailActionDelaysEnum | string) => {
  if (isCustomDateTimeValue(delay)) {
    return delay
  }

  switch (delay) {
    case 'two_hours':
      return convertToBackendStringDate(moment().add(2, 'hours'))
    case 'four_hours':
      return convertToBackendStringDate(moment().add(4, 'hours'))
    case 'six_hours':
      return convertToBackendStringDate(moment().add(6, 'hours'))
    case 'today_at_six_pm':
      if (moment().isBefore(moment().startOf('day').hour(18))) {
        return convertToBackendStringDate(moment().startOf('day').hour(18))
      }
      return null
    case 'tomorrow_at_nine_am':
      return convertToBackendStringDate(moment().add(1, 'day').startOf('day').hour(9))
    case 'next_monday_at_nine_am':
      return convertToBackendStringDate(moment().day(8).startOf('day').hour(9))
    default:
      return null
  }
}

const convertToBackendStringDate = (date: Moment) => {
  return dateToString(date, 'backend_datetime')
}
